/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'mail': {
    width: 32,
    height: 22,
    viewBox: '0 0 32 22',
    data: '<path pid="0" d="M29.5 22c.833 0 1.458-.375 1.875-1.125A4.82 4.82 0 0032 18.5V2.375a.277.277 0 00-.031-.125.966.966 0 00.015-.297.782.782 0 00-.078-.266c-.125-.562-.39-.984-.797-1.265C30.703.14 30.167 0 29.5 0h-26a4.91 4.91 0 00-1.766.328C1.161.547.72.865.406 1.281a.236.236 0 00-.094.078.512.512 0 01-.062.079 1.13 1.13 0 00-.219.39.727.727 0 000 .422.277.277 0 00-.031.125V18.5c0 .833.375 1.625 1.125 2.375S2.667 22 3.5 22h26zM16 12.781L2.531 2.031c.167-.02.334-.031.5-.031H29.5L16 12.781zM29.5 20h-26c-.27 0-.589-.182-.953-.547C2.182 19.09 2 18.771 2 18.5V4.187l13.344 10.657c.104.083.208.146.312.187a.918.918 0 00.344.063c.125 0 .24-.021.344-.063.104-.041.208-.104.312-.187L30 4.188V18.5c0 .27-.016.589-.047.953-.031.365-.182.547-.453.547z" _fill="#000" fill-rule="nonzero"/>'
  }
})
